export default (props, { rhythm }) => {
  return {
    root: {
      textAlign: 'center'
    },
    logo: {
      width: rhythm(8)
    }
  }
}
